import { Button } from "@/components/ui/button";
import { useTran } from "@/hooks";
import { observer } from "mobx-react-lite";
import { useESGReportListStore } from "../../../hooks/useESGReportListStore";
import { FormField } from "@/components/common";
import { Search } from "lucide-react";

const ESGReportsFilter = observer(() => {
  const { t } = useTran();
  const {
    search,
    setSearch,
    selectedStatus,
    setSelectedStatus,
    allCount,
    inProgressCount,
    completedCount,
  } = useESGReportListStore();

  const statuses = [
    { title: "All Reports", key: "all", count: allCount },
    { title: "In Progress", key: "in_progress", count: inProgressCount },
    { title: "Completed", key: "completed", count: completedCount },
  ];

  return (
    <div className="flex items-center justify-between">
      <div className="flex flex-wrap gap-2">
        {statuses.map((status) => {
          const isActive = status.key === selectedStatus;

          return (
            <Button
              variant={isActive ? "default" : "outline"}
              key={status.key}
              id={status.key}
              size="sm"
              onClick={() => setSelectedStatus(status.key)}
            >
              {t(status.title)}
              <div
                className={`px-2 py-1 flex items-center justify-center text-xs rounded-md ${isActive ? "bg-white/20 dark:bg-primary/30" : "bg-muted"}`}
              >
                {status.count}
              </div>
            </Button>
          );
        })}
      </div>
      <FormField
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        placeholder={t("Search Reports...")}
        className="w-full md:w-80"
        leftIcon={<Search size={16} />}
      />
    </div>
  );
});

export default ESGReportsFilter;
